import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.CompanyInfoStep', {
    title: 'Company information',
    requiredField: 'Field is required',
    dateMustBePast: 'The date must be in a past',
});
